export class Orgao {
  ativo: boolean;
  id: number;
  cnpj: string;
  email: string;
  razaoSocial: string;
  alias: string;
  telefone: string;
  tipoOrgaoId: number;
  enderecoId: number;
  responsavelId: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/shared/orgao.model.ts
 **/